import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default function VirtualReactiveEnergyPie({ importVal, exportVal }) {
    const data = [
        { name: "Reaktif Import", value: importVal || 0 },
        { name: "Reaktif Export", value: exportVal || 0 },
    ];

    return (
        <div className="bg-white p-5 border rounded-xl shadow">
            <h3 className="text-sm font-semibold mb-3">Reaktif Enerji Dağılımı</h3>

            <div className="w-full h-[320px] flex items-center justify-center">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="45%"        // ✔️ Pie yukarı kaydırıldı (tam ortalı)
                            outerRadius={100}
                            dataKey="value"
                        >
                            <Cell fill="#3B82F6" />  {/* Import */}
                            <Cell fill="#EF4444" />  {/* Export */}
                        </Pie>

                        <Tooltip formatter={(v) => `${Number(v).toFixed(3)} kVArh`} />

                        <Legend
                            verticalAlign="bottom"   // ✔️ Alta sabitlendi
                            height={36}              // ✔️ Pie ile çakışmaması için alan açıldı
                            wrapperStyle={{ paddingTop: 20 }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
